import React from "react";
import { Card, Container } from "react-bootstrap";
import "../../containers/styles.scss";
import { useHistory } from "react-router-dom";

interface IProps {
  index: number;
  id: string;
  title: string;
  description: string;
  imageURL: string;
  orderNo: number;
  thumbnail: string;
}

interface State {
  showAcceptConfirmation: boolean;
}

const CourseComponentView = (props: IProps) => {
  const history = useHistory();

  const getColor = (i: number) => {
    const colorNo = i % 9;
    switch (colorNo) {
      case 0:
        return "#142459";
      case 1:
        return "#29066B";
      case 2:
        return "#820401";
      case 3:
        return "#820401";
      case 4:
        return "#176BA0";
      case 5:
        return "#7D3AC1";
      case 6:
        return "#C02323";
      case 7:
        return "#19AADE";
      case 8:
        return "#AF4BCE";
      case 9:
        return "#DE542C";
    }
  };

  return (
    <Container>
      <div>
        <Card className="cont" style={{ width: "100%" }}>
          <div
            className="image-wrapper"
            style={
              props.thumbnail
                ? {
                    backgroundImage: `url(${props.thumbnail})`,
                    backgroundSize: "100% 100%",
                  }
                : { backgroundColor: getColor(props.index) }
            }
          >
            <h6
              style={{
                color: "white",
                padding: "10px 20px",
                backgroundColor: "#000",
                display: "inline-block",
                textAlign: "center",
                borderRadius: "0 0 10px 0",
              }}
            >
              Workshop {props.orderNo}
            </h6>
            <Card.Img className="image" variant="top" />
          </div>
          <Card.Body style={{ backgroundColor: "#f1f1f1" }}>
            <Card.Title
              style={{ fontSize: "16px" }}
              className="text-left multi-line-truncate"
            >
              <strong>{props.title}</strong>
            </Card.Title>

            <div className="text-center mt-4">
              <button
                style={{
                  width: "100%",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  history.push(`/workshop/${props.id}`);
                }}
                className="view-workshop"
              >
                View Workshop
              </button>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default CourseComponentView;
